import React from 'react';
import { Skeleton } from "../index";

import {
  CardTag,
  CardImageContainer,
  CardInfo,
  CardHotelInfo,
  CardHeading,
  CardDescription,
  CardFooter,
} from './styles';

const HotelSearchCardGhost = () => (
  <CardTag>
    <CardImageContainer>
      <Skeleton />
    </CardImageContainer>
    <CardInfo>
      <CardHotelInfo>
        <Skeleton />
      </CardHotelInfo>
      <CardHeading>
        <Skeleton />
      </CardHeading>
      <CardDescription>
        <Skeleton />
      </CardDescription>
      <CardFooter>
        <Skeleton />
      </CardFooter>
    </CardInfo>
  </CardTag>
);

export default HotelSearchCardGhost;
